import { closeAllTabs, setUser, signOutSuccess, useAppDispatch, useAppSelector } from '@/store'
import { logout } from '@/services/apiAuth'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function useAutoLogout() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { signedIn } = useAppSelector(state => state.auth.session)
    const user = useAppSelector(state => state.auth.user)

    let timeoutId

    const resetTimer = () => {
        if (timeoutId) clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
            logout().finally(()=> {
                dispatch(signOutSuccess())
                dispatch(closeAllTabs())
                dispatch(setUser(null))
                setTimeout(() => {
                    navigate('/login', { replace: true })
                }, 500)
            })
        }, 10 * 60 * 1000)
    }


    useEffect(() => {
        if (!signedIn || !user.usersAutoLogoutTimer) return

        window.addEventListener('mousemove', resetTimer)
        window.addEventListener('keypress', resetTimer)
        window.addEventListener('click', resetTimer)
        window.addEventListener('scroll', resetTimer)

        resetTimer()

        return () => {
            clearTimeout(timeoutId)
            window.removeEventListener('mousemove', resetTimer)
            window.removeEventListener('keypress', resetTimer)
            window.removeEventListener('click', resetTimer)
            window.removeEventListener('scroll', resetTimer)
        }
    }, [signedIn, user])
}
